import { SYN_API_URLS } from '@/constants/api';
import { WrappedBigNumber } from '@/entities/WrappedBigNumber';
import { IVaultInfo, IVaultStats } from '@/types/vault';
import { axiosGet } from '@/utils/axios';
import { getTokenInfo } from '@/utils/token';
import { Stage } from '@synfutures/sdks-perp-launchpad';
import _ from 'lodash';

// TODO: temp use list data until launchpad no longer need
const vaultInfoListData = {
  data: [
    {
      vaultAddress: '0xbf784aa443ae74af3fe94d33e0e8932ea882c33a',
      name: 'Ionic',
      status: 'INVALID',
      minQuoteAmount: '25.0',
      liveThreshold: '200000.0',
      liveThresholdUsd: '15.14656650929685',
      tokenInfo: {
        address: '0x3ee5e23eee121094f1cfc0ccc79d6c809ebd22e5',
        name: 'Ionic',
        symbol: 'ION',
        decimals: 18,
        price: 0.00007573283254648425,
      },
      assetPair: 'ION/ETH',
      assetPairLink: 'https://oyster.synfutures.com/#/trade/base/ETH-ION-EMG-Perpetual',
      tokenTvl: '68.778153114637620369',
      tokenUsdTvl: '0.0052087643526873050655',
      ooPoints: '0',
      ooPointsEpoch: 0,
      sort: 20,
      totalVolumeUsd: '2165991.002122681676595222572022237224',
      totalDeposit: '2351836.311553352523652831',
      totalWithdraw: '2339406.933618390194591746',
      allTimeEarned: '-12360.599781847691441',
      allTimeEarnedUsd: '-0.93610323345278096682',
      describe:
        'Ionic is a decentralised non-custodial money market protocol, supported by a comprehensive security monitoring and failsafe systems.',
      twitter: 'https://x.com/ionicmoney',
      telegram: 'https://t.me/ionicmoney',
      discord: 'https://discord.gg/FmgedqR9wn',
      website: 'https://t.co/hwZDVHk4OD',
      youtube: '',
      instagram: '',
      farcaster: '',
      tags: [
        {
          key: '1',
          title: 'S1 APY 12.80%',
          bgColor: '#FFAA0033',
          tooltips:
            'S1 APY is the annual yield derived from the Season 1 airdrop value relative to the TVL in the Launchpad.',
          textColor: '#FFAA00',
        },
      ],
    },
    {
      vaultAddress: '0xfbc439fec017c09519117cfca2c08c21a49f163b',
      name: 'WETH',
      status: 'INVALID',
      minQuoteAmount: '0.002',
      liveThreshold: '10.0',
      liveThresholdUsd: '29247.83768830132',
      tokenInfo: {
        address: '0x4200000000000000000000000000000000000006',
        name: 'Wrapped Ether',
        symbol: 'WETH',
        decimals: 18,
        price: 2924.783768830132,
      },
      assetPair: 'WETH/BTC',
      assetPairLink: 'https://oyster.synfutures.com/#/trade/base/BTC-WETH-LINK-Perpetual',
      tokenTvl: '0.021252713599950076',
      tokenUsdTvl: '62.159591780729385541',
      ooPoints: '0',
      ooPointsEpoch: 0,
      sort: 11,
      totalVolumeUsd: '200016997.934580829827590847441684813607',
      totalDeposit: '605.433217822825027379',
      totalWithdraw: '562.352478906575925909',
      allTimeEarned: '-43.059486202649151394',
      allTimeEarnedUsd: '-125939.686339673254',
      describe:
        'WETH is the tokenized/packaged form of ETH that you use to pay for items when you interact with Ethereum dApps.',
      twitter: '',
      telegram: '',
      discord: '',
      website: '',
      youtube: '',
      instagram: '',
      farcaster: '',
      tags: [],
    },
    {
      vaultAddress: '0xef0db9ac4b66956957ecb691f3705386b5f460f0',
      name: 'Tadpole',
      status: 'INVALID',
      minQuoteAmount: '2500.0',
      liveThreshold: '11909488.0',
      liveThresholdUsd: '490.30527708980977964',
      tokenInfo: {
        address: '0x55027a5b06f4340cc4c82dcc74c90ca93dcb173e',
        name: 'Tadpole',
        symbol: 'TAD',
        decimals: 18,
        price: 0.00004116929939303938,
      },
      assetPair: 'TAD/USDC',
      assetPairLink: 'https://oyster.synfutures.com/#/trade/base/USDC-TAD-EMG-Perpetual',
      tokenTvl: '23597546.573412968108479384',
      tokenUsdTvl: '971.49445982202900927',
      ooPoints: '0',
      ooPointsEpoch: 0,
      sort: 10,
      totalVolumeUsd: '1081052.509899782056827165243117360000',
      totalDeposit: '25737642.617004272037069207',
      totalWithdraw: '2602087.496488603677370258',
      allTimeEarned: '461991.45289729974848',
      allTimeEarnedUsd: '19.01986444135418385',
      describe:
        'Tadpole seeks to redefine value in the crypto space by merging the light-heartedness of meme tokens with the interactive potential of GameFi.',
      twitter: 'https://x.com/tadpolebase',
      telegram: '',
      discord: 'https://discord.gg/Cy969fCau6',
      website: 'https://www.tadpole.lol/',
      youtube: '',
      instagram: '',
      farcaster: 'https://warpcast.com/tadpolebase',
      tags: [],
    },
    {
      vaultAddress: '0xcdf9714e0e074c161a36ab0b2881ca73af1ec11b',
      name: 'Virtuals Protocol',
      status: 'LIVE',
      minQuoteAmount: '5.0',
      liveThreshold: '13800.0',
      liveThresholdUsd: '9729.02152114730916',
      tokenInfo: {
        address: '0x0b3e328455c4059eeb9e3f84b5543f74e24e7e1b',
        name: 'Virtual Protocol',
        symbol: 'VIRTUAL',
        decimals: 18,
        price: 0.7050015595034282,
      },
      assetPair: 'VIRTUAL/USDC',
      assetPairLink: 'https://oyster.synfutures.com/#/trade/base/USDC-VIRTUAL-EMG-Perpetual',
      tokenTvl: '5262.501457536708579139',
      tokenUsdTvl: '3710.0717344524434843',
      ooPoints: '0',
      ooPointsEpoch: 0,
      sort: 2,
      totalVolumeUsd: '656209.627038246685331669980402686541',
      totalDeposit: '14177.835692449585845449',
      totalWithdraw: '278.767811254227475954',
      allTimeEarned: '-8636.5664236586497899',
      allTimeEarnedUsd: '-6088.7927974342936746',
      describe:
        'Virtuals Protocol is a prominent AI agent generator platform launched in October 2024 on Ethereum Layer 2 Base.',
      twitter: '',
      telegram: '',
      discord: '',
      website: '',
      youtube: '',
      instagram: '',
      farcaster: '',
      tags: [],
    },
    {
      vaultAddress: '0xa535438fcb939bef8e88d019cbd24e94373d8564',
      name: 'BONSAI COIN',
      status: 'SUSPENDED',
      minQuoteAmount: '10000.0',
      liveThreshold: '5900000000000.0',
      liveThresholdUsd: '152802.1196545806767',
      tokenInfo: {
        address: '0xa0aebd4ae5f256b72b7d43f67ed934237adb1aee',
        name: 'BONSAI COIN',
        symbol: 'BONSAICOIN',
        decimals: 18,
        price: 2.5898664348234013e-8,
      },
      assetPair: '',
      assetPairLink: 'https://oyster.synfutures.com/#/trade/base/USDC-BONSAICOIN-EMG-Perpetual',
      tokenTvl: '0.0',
      tokenUsdTvl: '0',
      ooPoints: '0',
      ooPointsEpoch: 0,
      sort: 1,
      totalVolumeUsd: '0',
      totalDeposit: '6146368843923.255104352069021734',
      totalWithdraw: '6021340351084.084552757271203802',
      allTimeEarned: '-125028492839.17055159',
      allTimeEarnedUsd: '-3238.0709700072579551',
      describe: 'BONSAI COIN',
      twitter: '',
      telegram: '',
      discord: '',
      website: '',
      youtube: '',
      instagram: '',
      farcaster: '',
      tags: [],
    },
    {
      vaultAddress: '0x0f0c26bd4bc408fb3160c1dae23a071bad7bd2ff',
      name: 'PLAY Network',
      status: 'INVALID',
      minQuoteAmount: '77.0',
      liveThreshold: '15400000.0',
      liveThresholdUsd: '13850.9503061548311',
      tokenInfo: {
        address: '0x7404ac09adf614603d9c16a7ce85a1101f3514ba',
        name: 'PLAY',
        symbol: 'PLAY',
        decimals: 18,
        price: 0.0008994123575425215,
      },
      assetPair: 'PLAY/ETH',
      assetPairLink: 'https://oyster.synfutures.com/#/trade/base/ETH-PLAY-EMG-Perpetual',
      tokenTvl: '0.183806135540138749',
      tokenUsdTvl: '0.00016531750969693644071',
      ooPoints: '0',
      ooPointsEpoch: 0,
      sort: 1,
      totalVolumeUsd: '2718454.036620518317382439660873538900',
      totalDeposit: '55003813.458819979241469534',
      totalWithdraw: '51151238.734955180967208709',
      allTimeEarned: '-3852574.5400586627342',
      allTimeEarnedUsd: '-3465.0531496824572864',
      describe:
        'PLAY is a layer 0 protocol that enables AI agents to transact autonomously in games and social apps by bringing web2 games on-chain. Any game, any chain, any platform.',
      twitter: 'https://x.com/0xplay_network',
      telegram: 'https://t.me/PLAY_GameStore_Ann',
      discord: 'https://discord.gg/0xplay-network',
      website: 'https://theplay.network/',
      youtube: 'https://www.youtube.com/@0xplay_network',
      instagram: '',
      farcaster: '',
      tags: [],
    },
    {
      vaultAddress: '0x53173006bbd75b8fbe1e3c8b1bafd0a93d4f707e',
      name: 'Dypius',
      status: 'INVALID',
      minQuoteAmount: '200.0',
      liveThreshold: '4000000.0',
      liveThresholdUsd: '6124.4734322377828',
      tokenInfo: {
        address: '0x5b2124d427fac9c80c902cbdd74b03dd85d7d3fe',
        name: 'Dypius',
        symbol: 'DYP',
        decimals: 18,
        price: 0.0015311183580594457,
      },
      assetPair: 'DYP/ETH',
      assetPairLink: 'https://oyster.synfutures.com/#/trade/base/ETH-DYP-EMG-Perpetual',
      tokenTvl: '0.000000000000000001',
      tokenUsdTvl: '1.5311183580594457e-21',
      ooPoints: '0',
      ooPointsEpoch: 0,
      sort: 1,
      totalVolumeUsd: '946576.522574109456211063854835449428',
      totalDeposit: '4384379.4824690817415973',
      totalWithdraw: '1602642.666213228364342996',
      allTimeEarned: '-2781736.8162558533773',
      allTimeEarnedUsd: '-4259.1683066591722232',
      describe:
        'Dypius is a powerful, decentralized ecosystem with a focus on scalability, security, and global adoption.',
      twitter: 'https://x.com/dypius',
      telegram: 'https://t.me/dypannouncements',
      discord: 'https://discord.gg/worldofdypians',
      website: 'https://www.dypius.com/',
      youtube: '',
      instagram: 'https://www.instagram.com/dyp.eth/#',
      farcaster: '',
      tags: [],
    },
    {
      vaultAddress: '0xc50019baa6b1214963cde4c881fa1ab41e140f83',
      name: 'Talent Protocol',
      status: 'INVALID',
      minQuoteAmount: '85.0',
      liveThreshold: '1500000.0',
      liveThresholdUsd: '3633.6644407594425',
      tokenInfo: {
        address: '0x9a33406165f562e16c3abd82fd1185482e01b49a',
        name: 'TalentProtocolToken',
        symbol: 'TALENT',
        decimals: 18,
        price: 0.002422442960506295,
      },
      assetPair: 'TALENT/ETH',
      assetPairLink: 'https://oyster.synfutures.com/#/trade/base/ETH-TALENT-EMG-Perpetual',
      tokenTvl: '453.314686855930043898',
      tokenUsdTvl: '1.0981289720682632285',
      ooPoints: '0',
      ooPointsEpoch: 0,
      sort: 1,
      totalVolumeUsd: '2784950.280652621620354369196847356600',
      totalDeposit: '1503445.827514737180134204',
      totalWithdraw: '369737.823301868431198199',
      allTimeEarned: '-1133254.6895260128189',
      allTimeEarnedUsd: '-2745.244845103036673',
      describe:
        'Talent Protocol is a professional reputation ecosystem, that aggregates verifiable user data under one onchain identity, and assigns each user a Builder Score.',
      twitter: 'https://x.com/TalentProtocol',
      telegram: 'http://t.me/talentprotocol',
      discord: 'https://discord.com/invite/talentprotocol',
      website: 'https://www.talentprotocol.com/',
      youtube: '',
      instagram: '',
      farcaster: 'https://warpcast.com/talent',
      tags: [],
    },
    {
      vaultAddress: '0xabc244a47fd517d60e916f6ac2a3862b4ddbdb3f',
      name: 'Moonwell',
      status: 'LIVE',
      minQuoteAmount: '100.0',
      liveThreshold: '9100000.0',
      liveThresholdUsd: '79830.6268909574334',
      tokenInfo: {
        address: '0xa88594d404727625a9437c3f886c7643872296ae',
        name: 'WELL',
        symbol: 'WELL',
        decimals: 18,
        price: 0.008772596361643674,
      },
      assetPair: 'WELL/ETH',
      assetPairLink: 'https://oyster.synfutures.com/#/trade/base/ETH-WELL-LINK-Perpetual',
      tokenTvl: '4934903.260052001658778741',
      tokenUsdTvl: '43291.914384195695344',
      ooPoints: '0',
      ooPointsEpoch: 0,
      sort: 1,
      totalVolumeUsd: '15546235.336197335905875779914001308764',
      totalDeposit: '9100979.872252095710850872',
      totalWithdraw: '533.273018506621528569',
      allTimeEarned: '-4165543.3391815874305',
      allTimeEarnedUsd: '-36542.630341573434554',
      describe: 'Moonwell is a leading DeFi lending & borrowing protocol on Base with $400M+ in TVL.',
      twitter: 'https://x.com/MoonwellDeFi',
      telegram: 'https://t.me/moonwellfichat',
      discord: 'https://discord.com/invite/moonwellfi',
      website: 'https://moonwell.fi/',
      youtube: '',
      instagram: '',
      farcaster: '',
      tags: [],
    },
    {
      vaultAddress: '0xeccfac92cf80c8b67101934d21c4ab51996e4298',
      name: 'GenomesDAO',
      status: 'INVALID',
      minQuoteAmount: '100.0',
      liveThreshold: '3775000.0',
      liveThresholdUsd: '3708.11295645821414',
      tokenInfo: {
        address: '0x1db0c569ebb4a8b57ac01833b9792f526305e062',
        name: 'GENOME',
        symbol: 'GENOME',
        decimals: 18,
        price: 0.0009822815778697256,
      },
      assetPair: 'GENOME/USDC',
      assetPairLink: 'https://oyster.synfutures.com/#/trade/base/USDC-GENOME-EMG-Perpetual',
      tokenTvl: '0.0',
      tokenUsdTvl: '0',
      ooPoints: '0',
      ooPointsEpoch: 0,
      sort: 1,
      totalVolumeUsd: '8644310.922818647263900344114422384837',
      totalDeposit: '3775000.0',
      totalWithdraw: '421850.18503275864741059',
      allTimeEarned: '-3353149.8149672413526',
      allTimeEarnedUsd: '-3293.7372910796002739',
      describe:
        'GenomesDAO is a platform for safe, private & auditable monetization of genomic data using DeFi and DeSci.',
      twitter: 'https://x.com/genomesdao',
      telegram: 'https://t.me/genomesdotio',
      discord: 'https://discord.com/invite/3DaD2na4XJ',
      website: 'https://genomes.io/',
      youtube: '',
      instagram: '',
      farcaster: '',
      tags: [],
    },
    {
      vaultAddress: '0xe4b14eb07794e93ebc275c8300590c1fd8748de6',
      name: 'Bitcoin USD',
      status: 'INVALID',
      minQuoteAmount: '10.0',
      liveThreshold: '1000000.0',
      liveThresholdUsd: '999321.5',
      tokenInfo: {
        address: '0xe4b20925d9e9a62f1e492e15a81dc0de62804dd4',
        name: 'Bitcoin USD',
        symbol: 'BtcUSD',
        decimals: 18,
        price: 0.9993215,
      },
      assetPair: 'JPY/BtcUSD',
      assetPairLink: 'https://oyster.synfutures.com/#/trade/base/JPY-BtcUSD-EMG-Perpetual',
      tokenTvl: '0.0',
      tokenUsdTvl: '0',
      ooPoints: '0',
      ooPointsEpoch: 0,
      sort: 1,
      totalVolumeUsd: '145683787.686086078663694932799154000000',
      totalDeposit: '1502509.216045932019750214',
      totalWithdraw: '1448920.426631514472482477',
      allTimeEarned: '-53588.789414417547268',
      allTimeEarnedUsd: '-53552.429420799864962',
      describe:
        'Bifrost is an EVM-compatible Layer 1 blockchain connecting Web3 and Web2, powered by BTCFi to unlock Bitcoin banking.',
      twitter: 'https://x.com/Bifrost_Network',
      telegram: 'https://t.me/Bifrostnotice',
      discord: 'https://discord.gg/bifrostcity',
      website: 'https://bifrostnetwork.com/',
      youtube: '',
      instagram: '',
      farcaster: '',
      tags: [],
    },
    {
      vaultAddress: '0x89c2e7c2472ce329906d823810111b3187661a50',
      name: 'Dtravel',
      status: 'INVALID',
      minQuoteAmount: '50.0',
      liveThreshold: '1730000.0',
      liveThresholdUsd: '3183.299732965686009',
      tokenInfo: {
        address: '0x74aa9bb52b36a378a6e641b86d7acb76dc9b3940',
        name: 'TRVL',
        symbol: 'TRVL',
        decimals: 18,
        price: 0.0018400576491131133,
      },
      assetPair: 'TRVL/ETH',
      assetPairLink: 'https://oyster.synfutures.com/#/trade/base/ETH-TRVL-EMG-Perpetual',
      tokenTvl: '1520.035991116722665477',
      tokenUsdTvl: '2.7969538523815578795',
      ooPoints: '0',
      ooPointsEpoch: 0,
      sort: 1,
      totalVolumeUsd: '7692378.693259565269220659844627310798',
      totalDeposit: '1730000.0',
      totalWithdraw: '0.0',
      allTimeEarned: '-1728479.9640088832773',
      allTimeEarnedUsd: '-3180.5027791133044511',
      describe: 'Dtravel is a dencentralized network of independently owned vacation rental listings',
      twitter: 'https://x.com/DtravelDAO',
      telegram: 'https://t.me/dtravelcommunity',
      discord: 'https://discord.com/invite/dtravel',
      website: 'https://www.dtravel.com/',
      youtube: '',
      instagram: '',
      farcaster: '',
      tags: [],
    },
    {
      vaultAddress: '0xfdc1bb2f117e59d2a5681345a1711ee2dd1ce4ba',
      name: 'Resolv USD',
      status: 'INVALID',
      minQuoteAmount: '2.0',
      liveThreshold: '100000.0',
      liveThresholdUsd: '99942.20035030292',
      tokenInfo: {
        address: '0x35e5db674d8e93a03d814fa0ada70731efe8a4b9',
        name: 'Resolv USD',
        symbol: 'USR',
        decimals: 18,
        price: 0.9994220035030292,
      },
      assetPair: 'BTC/USR',
      assetPairLink: 'https://oyster.synfutures.com/#/trade/base/BTC-USR-EMG-Perpetual',
      tokenTvl: '140.940008473519305795',
      tokenUsdTvl: '140.85854564233857677',
      ooPoints: '0',
      ooPointsEpoch: 0,
      sort: 1,
      totalVolumeUsd: '3929773.332980595624589097291365063351',
      totalDeposit: '102250.247105191045921584',
      totalWithdraw: '96862.28998218734492769',
      allTimeEarned: '-5247.0171145301816881',
      allTimeEarnedUsd: '-5243.9843570184374082',
      describe: 'Trustless stablecoin and low-risk crypto investments backed by the True-Delta Neutral Architecture.',
      twitter: 'https://x.com/ResolvLabs',
      telegram: 'https://t.me/Resolv_Community',
      discord: 'https://discord.gg/resolv',
      website: 'https://resolv.xyz/',
      youtube: '',
      instagram: '',
      farcaster: '',
      tags: [],
    },
    {
      vaultAddress: '0xb39c8375abc3173f9843c8d8b943649728d1ea45',
      name: 'Alien Base',
      status: 'LIVE',
      minQuoteAmount: '5.0',
      liveThreshold: '287000.0',
      liveThresholdUsd: '4749.08786028063044',
      tokenInfo: {
        address: '0x1dd2d631c92b1acdfcdd51a0f7145a50130050c4',
        name: 'AlienBase Token',
        symbol: 'ALB',
        decimals: 18,
        price: 0.01654734446090812,
      },
      assetPair: 'ALB/USDC',
      assetPairLink: 'https://oyster.synfutures.com/#/trade/base/USDC-ALB-EMG-Perpetual',
      tokenTvl: '332805.154818016441746204',
      tokenUsdTvl: '5507.0415351395736927',
      ooPoints: '0',
      ooPointsEpoch: 0,
      sort: 1,
      totalVolumeUsd: '1587392.081337717287402709654644837100',
      totalDeposit: '437103.242554468299393104',
      totalWithdraw: '150113.773005777717668132',
      allTimeEarned: '45815.685269325860026',
      allTimeEarnedUsd: '758.12792586408901794',
      describe: 'AlienBase is the Base-native DEX for degen earthlings.',
      twitter: 'https://x.com/AlienBaseDEX',
      telegram: '',
      discord: 'https://discord.gg/alienbase',
      website: 'https://alienbase.xyz/',
      youtube: '',
      instagram: '',
      farcaster: '',
      tags: [],
    },
    {
      vaultAddress: '0x90471f8c9c9a01a6a3fea20d17b9a083e271cec6',
      name: 'PumpBTC',
      status: 'LIVE',
      minQuoteAmount: '0.0001',
      liveThreshold: '1.0',
      liveThresholdUsd: '82774.5845527781',
      tokenInfo: {
        address: '0xf469fbd2abcd6b9de8e169d128226c0fc90a012e',
        name: 'pumpBTC',
        symbol: 'pumpBTC',
        decimals: 8,
        price: 82774.5845527781,
      },
      assetPair: 'pumpBTC/BTC',
      assetPairLink: 'https://oyster.synfutures.com/#/trade/base/BTC-pumpBTC-EMG-Perpetual',
      tokenTvl: '19.61125076',
      tokenUsdTvl: '1623313.1342193537737',
      ooPoints: '0',
      ooPointsEpoch: 0,
      sort: 1,
      totalVolumeUsd: '47258855.589176987066503841679653735920',
      totalDeposit: '160.38968087',
      totalWithdraw: '140.48634327',
      allTimeEarned: '-0.29208684',
      allTimeEarnedUsd: '-24177.36683433376845',
      describe:
        'PumpBTC’s aim to allow Bitcoin holders to maximize their returns by participating in DeFi with security, scalability, and transparency.',
      twitter: 'https://x.com/Pumpbtcxyz',
      telegram: '',
      discord: 'https://discord.gg/pumpbtc',
      website: 'https://mainnet.pumpbtc.xyz/',
      youtube: '',
      instagram: '',
      farcaster: '',
      tags: [
        {
          key: '1',
          title: 'S1 APY 1.60%',
          bgColor: '#FFAA0033',
          tooltips:
            'S1 APY is the annual yield derived from the Season 1 airdrop value relative to the TVL in the Launchpad.',
          textColor: '#FFAA00',
        },
      ],
    },
    {
      vaultAddress: '0x2f08aac33ce274be364e9fbdc39f088e3d26a220',
      name: 'cbBTC',
      status: 'INVALID',
      minQuoteAmount: '0.0001',
      liveThreshold: '1.0',
      liveThresholdUsd: '86008.98976461588',
      tokenInfo: {
        address: '0xcbb7c0000ab88b473b1f5afd9ef808440eed33bf',
        name: 'Coinbase Wrapped BTC',
        symbol: 'cbBTC',
        decimals: 8,
        price: 86008.98976461588,
      },
      assetPair: 'cbBTC/BTC',
      assetPairLink: 'https://oyster.synfutures.com/#/trade/base/BTC-cbBTC-EMG-Perpetual',
      tokenTvl: '0.0',
      tokenUsdTvl: '0',
      ooPoints: '0',
      ooPointsEpoch: 0,
      sort: 1,
      totalVolumeUsd: '0',
      totalDeposit: '0.00020295',
      totalWithdraw: '0.00020295',
      allTimeEarned: '0',
      allTimeEarnedUsd: '0',
      describe: '',
      twitter: '',
      telegram: '',
      discord: '',
      website: '',
      youtube: '',
      instagram: '',
      farcaster: '',
      tags: [],
    },
    {
      vaultAddress: '0x666f5036ce5ed9893feaf928703d277b3cd9e997',
      name: 'Blocklords',
      status: 'LIVE',
      minQuoteAmount: '5.0',
      liveThreshold: '150000.0',
      liveThresholdUsd: '6709.026612641604',
      tokenInfo: {
        address: '0xb676f87a6e701f0de8de5ab91b56b66109766db1',
        name: 'BLOCKLORDS',
        symbol: 'LRDS',
        decimals: 18,
        price: 0.04472684408427736,
      },
      assetPair: 'LRDS/USDC',
      assetPairLink: 'https://oyster.synfutures.com/#/trade/base/USDC-LRDS-EMG-Perpetual',
      tokenTvl: '99820.782910862612849306',
      tokenUsdTvl: '4464.6685936246500472',
      ooPoints: '0',
      ooPointsEpoch: 0,
      sort: 1,
      totalVolumeUsd: '1716378.319999147823604518692868378152',
      totalDeposit: '204421.4503372272789286',
      totalWithdraw: '4411.930875991133455886',
      allTimeEarned: '-100188.73655037353262',
      allTimeEarnedUsd: '-4481.1259986892973534',
      describe: 'BLOCKLORDS is a revolutionary MMO gaming experience with exceptional user acquisition potential.',
      twitter: 'https://x.com/BLOCKLORDS',
      telegram: 'https://bit.ly/BLocklordsTG',
      discord: 'https://bit.ly/DiscordBlocklords',
      website: 'https://blocklords.com/',
      youtube: '',
      instagram: 'https://www.instagram.com/blocklords.game/',
      farcaster: '',
      tags: [
        {
          key: '1',
          title: 'S1 APY 8.78%',
          bgColor: '#FFAA0033',
          tooltips:
            'S1 APY is the annual yield derived from the Season 1 airdrop value relative to the TVL in the Launchpad.',
          textColor: '#FFAA00',
        },
      ],
    },
    {
      vaultAddress: '0xa0a299b014bc33e1f5fbed865d6d2467e9cce895',
      name: 'Solv Protocol',
      status: 'INVALID',
      minQuoteAmount: '0.0001',
      liveThreshold: '1.0',
      liveThresholdUsd: '85949.39133255756',
      tokenInfo: {
        address: '0x3b86ad95859b6ab773f55f8d94b4b9d443ee931f',
        name: 'Solv BTC',
        symbol: 'SolvBTC',
        decimals: 18,
        price: 85949.39133255756,
      },
      assetPair: 'SolvBTC/BTC',
      assetPairLink: 'https://oyster.synfutures.com/#/trade/base/BTC-SolvBTC-EMG-Perpetual',
      tokenTvl: '0.032746547901199451',
      tokenUsdTvl: '2814.5458603505330514',
      ooPoints: '0',
      ooPointsEpoch: 0,
      sort: 1,
      totalVolumeUsd: '0',
      totalDeposit: '9.139330483755135209',
      totalWithdraw: '9.106583935853935758',
      allTimeEarned: '0',
      allTimeEarnedUsd: '0',
      describe:
        'Solv Protocol is revolutionizing yield aggregation and liquidity management by tokenizing and consolidating high-quality yields from diverse sources.',
      twitter: 'https://x.com/SolvProtocol',
      telegram: 'https://t.me/Solv_Protocol',
      discord: 'https://discord.com/invite/solvprotocol',
      website: 'https://solv.finance/',
      youtube: '',
      instagram: '',
      farcaster: '',
      tags: [],
    },
    {
      vaultAddress: '0x152d6356da0b84eb796247b03b3a17a791d83c42',
      name: 'Klima DAO',
      status: 'INVALID',
      minQuoteAmount: '10.0',
      liveThreshold: '10000.0',
      liveThresholdUsd: '738.4441155753992',
      tokenInfo: {
        address: '0xdcefd8c8fcc492630b943abcab3429f12ea9fea2',
        name: 'Klima DAO',
        symbol: 'KLIMA',
        decimals: 9,
        price: 0.07384441155753992,
      },
      assetPair: 'KLIMA/ETH',
      assetPairLink: 'https://oyster.synfutures.com/#/trade/base/ETH-KLIMA-EMG-Perpetual',
      tokenTvl: '177.156069086',
      tokenUsdTvl: '13.081985675502558932',
      ooPoints: '0',
      ooPointsEpoch: 0,
      sort: 1,
      totalVolumeUsd: '33831799.582475176710674303990526418796',
      totalDeposit: '1008400.85938176',
      totalWithdraw: '970536.436927616',
      allTimeEarned: '-37687.266385058',
      allTimeEarnedUsd: '-2782.9940094168626962',
      describe: 'The liquidity hub for carbon on-chain | Builders of decentralized climate finance',
      twitter: 'https://x.com/KlimaDAO',
      telegram: 'https://t.me/KlimaDAO_Official',
      discord: 'https://discord.com/invite/klimadao',
      website: 'https://www.klimadao.finance/',
      youtube: 'https://www.youtube.com/@KlimaDAOfinance',
      instagram: '',
      farcaster: '',
      tags: [
        {
          key: '1',
          title: 'S1 APY 23.04%',
          bgColor: '#FFAA0033',
          tooltips:
            'S1 APY is the annual yield derived from the Season 1 airdrop value relative to the TVL in the Launchpad.',
          textColor: '#FFAA00',
        },
      ],
    },
    {
      vaultAddress: '0xe6890159496c7ca5c343a86a550d9bd4060e8fc5',
      name: 'Solv Protocol',
      status: 'INVALID',
      minQuoteAmount: '0.0001',
      liveThreshold: '1.0',
      liveThresholdUsd: '85949.39133255756',
      tokenInfo: {
        address: '0x3b86ad95859b6ab773f55f8d94b4b9d443ee931f',
        name: 'Solv BTC',
        symbol: 'SolvBTC',
        decimals: 18,
        price: 85949.39133255756,
      },
      assetPair: 'SolvBTC/BTC',
      assetPairLink: 'https://oyster.synfutures.com/#/trade/base/BTC-SolvBTC-EMG-Perpetual',
      tokenTvl: '0.001998715761440178',
      tokenUsdTvl: '171.78840314257261879',
      ooPoints: '0',
      ooPointsEpoch: 0,
      sort: 1,
      totalVolumeUsd: '39955999.267744772643089278177158207880',
      totalDeposit: '83.598876033197916487',
      totalWithdraw: '83.306146865319175293',
      allTimeEarned: '-0.290730452117301016',
      allTimeEarnedUsd: '-24988.105401321292663',
      describe:
        'Solv Protocol is revolutionizing yield aggregation and liquidity management by tokenizing and consolidating high-quality yields from diverse sources.',
      twitter: 'https://x.com/SolvProtocol',
      telegram: 'https://t.me/Solv_Protocol',
      discord: 'https://discord.com/invite/solvprotocol',
      website: 'https://solv.finance/',
      youtube: '',
      instagram: '',
      farcaster: '',
      tags: [
        {
          key: '1',
          title: 'S1 APY 4.02%',
          bgColor: '#FFAA0033',
          tooltips:
            'S1 APY is the annual yield derived from the Season 1 airdrop value relative to the TVL in the Launchpad.',
          textColor: '#FFAA00',
        },
      ],
    },
  ],
  code: 200,
  message: 'success',
};

export const fetchVaultInfos = async ({
  chainId,
}: {
  chainId: number;
  userAddr: string | undefined;
}): Promise<Record<string, IVaultInfo> | undefined> => {
  // const res = await axiosGet({
  //   url: SYN_API_URLS.VAULT.INFOS,
  //   config: {
  //     params: userAddr
  //       ? {
  //           chainId,
  //           address: userAddr,
  //         }
  //       : {
  //           chainId,
  //         },
  //   },
  // });

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const data = (vaultInfoListData as any)?.data?.map((v: IVaultInfo) => ({
    ...v,
    vaultAddr: v.vaultAddress,
    tokenInfo: getTokenInfo(v.tokenInfo, chainId),
    minQuoteAmount: WrappedBigNumber.from(v.minQuoteAmount),
    liveThreshold: WrappedBigNumber.from(v.liveThreshold),
    tokenTvl: WrappedBigNumber.from(v.tokenTvl),
    tokenUsdTvl: WrappedBigNumber.from(v.tokenUsdTvl),
    ooPoints: WrappedBigNumber.from(v.ooPoints),
    stageForUi:
      WrappedBigNumber.from(v.tokenTvl).gte(v.liveThreshold) && v.status === Stage.UPCOMING ? Stage.LIVE : v.status,
  }));
  // ?.filter((v: IVaultInfo) => v.status !== Stage.INVALID && v.status !== Stage.SUSPENDED)
  return _.keyBy(data, 'vaultAddress');
};

export const fetchVaultSummary = async ({ chainId }: { chainId: number }): Promise<IVaultStats | undefined> => {
  const res = await axiosGet({
    url: SYN_API_URLS.VAULT.SUMMARY,
    domain: 'https://api.synfutures.com',
    config: {
      params: {
        chainid: chainId,
      },
    },
  });

  if (res?.data?.data) {
    return {
      ...res.data.data,
      totalTvlUsd: WrappedBigNumber.from(res.data.data.totalTvlUsd),
      totalVolumeUsd: WrappedBigNumber.from(res.data.data.totalVolumeUsd),
      allTimeEarnedUsd: WrappedBigNumber.from(res.data.data.allTimeEarnedUsd),
      count: WrappedBigNumber.from(res.data.data.count),
    };
  }
};
